/**
 * Pdf portal
 * Portal to generate PDF and handle authentication.
 *
 * OpenAPI spec version: 1.0.32
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * * `female` - female * `male` - male
 */
export type GenderEnum = 'female' | 'male';

export const GenderEnum = {
    Female: 'female' as GenderEnum,
    Male: 'male' as GenderEnum
};